import { CanDeactivateFn } from '@angular/router';
import { TestStepFormComponent } from './test-step-form.component';

export const canDeactivateTestStepForm: CanDeactivateFn<TestStepFormComponent> = (component) => {
  if (component.hasUnsavedChanges()) {
    return component.confirmDeactivate();
  }
  return true;
};
